module.exports = __webpack_public_path__ + "static/media/eft.b8f0c28a.svg";